import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const fuelfilterConditionService = {
    getAllfuelfilterConditions,
    getfuelfilterCondition,
    updatefuelfilterCondition,
    createfuelfilterCondition,
    updatefuelfilterConditionStatus
};

const MODULE = {
    CONDITION: 'fuel-filter-conditions',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllfuelfilterConditions(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.CONDITION}`, requestOptions)
  }

  export function getfuelfilterCondition(id) {   
    return apiHelper(API_URL).get(`/${MODULE.CONDITION}/${id}`)
  }

  export function updatefuelfilterCondition(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.CONDITION}/${data.id}`, requestOptions)
  }

  export function createfuelfilterCondition(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.CONDITION}`, requestOptions)
  }

  export function updatefuelfilterConditionStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.CONDITION}/${data.id}`, requestOptions)
    
  }